import {cast, Instance, SnapshotOut, types} from "mobx-state-tree"
import {ActionModel, ActionSnapshot} from "../action/action";
import {ActionFirestore} from "../../services/firestore/action-firestore";
import {generateKey} from "../../utils/random";

/**
 * Example store containing Rick and Morty characters
 */
export const ActionStoreModel = types
    .model("ActionStore")
    .props({
        actions: types.maybe(types.array(ActionModel)),
        isLoadingActions: types.optional(types.boolean, false)
    })
    .actions((self) => ({
        saveActions: async (data: ActionSnapshot[]) => {
            self.actions = cast(data)
            self.isLoadingActions = false
        },
    }))
    .actions((self) => ({
        getActions: async (projectId: string) => {
            self.isLoadingActions = true
            const actionFirestore = new ActionFirestore()
            const result = await actionFirestore.getActions(projectId)

            if (result.kind === "ok" && result.data !== undefined) {
                self.saveActions(result.data)
                return result.data
            } else {
                console.log(result.kind)
                self.isLoadingActions = false
                return null
            }
        },
        refreshActions: async (projectId: string) => {
            const actionFirestore = new ActionFirestore()
            const result = await actionFirestore.getActions(projectId)

            if (result.kind === "ok" && result.data !== undefined) {
                self.saveActions(result.data)
            }
        },
    }))
    .actions((self) => ({
        addAction: async (formData: {
            name: string,
            amount: number,
            direction: string
        }, businessId, projectId) => {
            const actionFirestore = new ActionFirestore()
            const result = await actionFirestore.addAction(formData, businessId, projectId)

            if (result.kind === "ok") {
                await self.refreshActions(projectId)
                return true
            } else {
                console.log(result.kind)
                return false
            }
        },
        updateAction: async (id, formData: {
            name: string,
            amount: number,
            direction: string
        }, projectId) => {
            const actionFirestore = new ActionFirestore()
            const result = await actionFirestore.updateAction(id, formData)

            if (result.kind === "ok") {
                await self.refreshActions(projectId)
                return true
            } else {
                console.log(result.kind)
                return false
            }
        },
        revokeActionKey: async (id, projectId) => {
            const actionFirestore = new ActionFirestore()
            const result = await actionFirestore.revokeActionKey(id, generateKey())

            if (result.kind === "ok") {
                await self.refreshActions(projectId)
                return true
            } else {
                console.log(result.kind)
                return false
            }
        },
        deleteAction: async (id, projectId) => {
            const actionFirestore = new ActionFirestore()
            const result = await actionFirestore.deleteAction(id)

            if (result.kind === "ok") {
                await self.refreshActions(projectId)
                return true
            } else {
                console.log(result.kind)
                return false
            }
        },

    }))

type ActionStoreType = Instance<typeof ActionStoreModel>

export interface ActionStore extends ActionStoreType {
}

type ActionStoreSnapshotType = SnapshotOut<typeof ActionStoreModel>

export interface ActionStoreSnapshot extends ActionStoreSnapshotType {
}

export const createActionStoreDefaultModel = () => types.optional(ActionStoreModel, {})
